export function getGoogleMapsApiKey() {
  if (typeof process !== "undefined" && process.env?.VUE_APP_GOOGLE_MAPS_KEY) {
    return process.env.VUE_APP_GOOGLE_MAPS_KEY;
  }

  if (
    typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_GOOGLE_MAPS_KEY
  ) {
    return import.meta.env.VITE_GOOGLE_MAPS_KEY;
  }

  return "";
}
